import { Configuration, PrinterDeviceStatus, PrinterSocketStatus } from '../Interfaces/configuration'

const nowIso = () => new Date().toISOString()

const buildDefaultSocketStatus = (legacyVerified = false): PrinterSocketStatus => ({
  status: legacyVerified ? 'online' : 'offline',
  connectedClients: legacyVerified ? 1 : 0,
  timestamp: nowIso(),
  message: legacyVerified
    ? 'Conexão inferida a partir do status legado.'
    : 'Sem dados de conexão do socket.',
  verified: legacyVerified,
})

const buildDefaultDeviceStatus = (printerName = ''): PrinterDeviceStatus => ({
  status: printerName ? 'offline' : 'not_configured',
  printerName,
  timestamp: nowIso(),
  message: printerName ? 'Aguardando verificação da impressora.' : 'Nenhuma impressora configurada.',
  socketId: null,
  verified: false,
})

export const mapPrinterStatusLabel = (status?: string) => {
  const statusMap: Record<string, string> = {
    online: 'ativo',
    offline: 'inativo',
    error: 'erro',
    not_configured: 'não configurado',
  }
  const normalized = (status || '').toLowerCase()
  return statusMap[normalized] || status || 'desconhecido'
}

export const resolvePrinterStatuses = (config?: Partial<Configuration>) => {
  const configuredName = (config?.printer_name || '').trim()
  const legacyDevice = config?.printerStatus

  const printerDeviceStatus: PrinterDeviceStatus = config?.printerDeviceStatus
    ? {
        ...config.printerDeviceStatus,
        printerName:
          config.printerDeviceStatus.printerName || legacyDevice?.printerName || configuredName,
      }
    : legacyDevice
      ? {
          ...legacyDevice,
          printerName: legacyDevice.printerName || configuredName,
        }
      : buildDefaultDeviceStatus(configuredName)

  const legacyVerified = Boolean(legacyDevice?.verified)
  const printerSocketStatus: PrinterSocketStatus = config?.printerSocketStatus
    ? config.printerSocketStatus
    : buildDefaultSocketStatus(legacyVerified)

  const printerName = (printerDeviceStatus.printerName || configuredName || '').trim()
  const isSocketOnline = (printerSocketStatus.status || '').toLowerCase() === 'online'
  const isDeviceOnline = (printerDeviceStatus.status || '').toLowerCase() === 'online'

  return {
    printerName,
    printerSocketStatus,
    printerDeviceStatus: { ...printerDeviceStatus, printerName },
    isSocketOnline,
    isDeviceOnline,
    isPrintable: Boolean(printerName) && isSocketOnline && isDeviceOnline,
  }
}
